var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8155 8.62726C16.9335 8.74514 17 8.90534 17 9.0722C17 9.23821 16.9335 9.39843 16.8155 9.51628L13.3019 13.0251C13.0567 13.2708 12.6577 13.2708 12.4124 13.0251C12.1664 12.7794 12.1664 12.3818 12.4124 12.1361L14.8736 9.67829H4.05611C3.88737 9.68161 3.72445 9.61686 3.60393 9.49899C3.4834 9.38029 3.41524 9.21926 3.41524 9.04992C3.41524 8.88141 3.4834 8.71954 3.60393 8.60167C3.72446 8.4838 3.88737 8.41822 4.05611 8.42154H14.8295L12.4124 6.00776C12.1664 5.76207 12.1664 5.36446 12.4124 5.11874C12.6576 4.87388 13.0566 4.87388 13.3019 5.11874L16.8155 8.62726ZM1.68406 17.5H5.47026C5.81356 17.4933 6.08785 17.2144 6.08785 16.8716C6.08785 16.5288 5.81354 16.2491 5.47026 16.2433H1.68406C1.45047 16.2399 1.26179 16.0515 1.25847 15.8183V2.18172C1.2618 1.94846 1.45048 1.76004 1.68406 1.75672H5.47026C5.81356 1.75091 6.08785 1.47117 6.08785 1.12836C6.08785 0.786365 5.81354 0.50663 5.47026 0.5H1.68406C0.754751 0.50166 0.000829888 1.25372 0 2.18257V15.8183C0.000831165 16.7463 0.754751 17.4991 1.68406 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutVector);
export default __webpack_public_path__ + "static/media/logoutVector.13c1c2a1ca2776008d575e5078ade693.svg";
export { ForwardRef as ReactComponent };